/** Shared utilities for report pages */

/** Format a number as GBP currency with two decimal places */
export const fmt = (n: number) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);

/** Format a number as GBP with no decimal places (summary cards) */
export const fmtRound = (n: number) =>
  new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: 0,
  }).format(n);

/** Derive the "as of" date string from the period selector */
export const dateForPeriod = (period: string): string => {
  const now = new Date();
  switch (period) {
    case "currentMonth":
      return new Date(now.getFullYear(), now.getMonth() + 1, 0)
        .toISOString()
        .split("T")[0];
    case "lastMonth":
      return new Date(now.getFullYear(), now.getMonth(), 0)
        .toISOString()
        .split("T")[0];
    case "currentQuarter": {
      const q = Math.floor(now.getMonth() / 3);
      return new Date(now.getFullYear(), q * 3 + 3, 0)
        .toISOString()
        .split("T")[0];
    }
    case "lastQuarter": {
      const lq = Math.floor(now.getMonth() / 3) - 1;
      return new Date(now.getFullYear(), lq * 3 + 3, 0)
        .toISOString()
        .split("T")[0];
    }
    case "lastYear":
      return `${now.getFullYear() - 1}-12-31`;
    case "currentYear":
    default:
      return now.toISOString().split("T")[0];
  }
};

/** Derive the year string from the period selector */
export const yearForPeriod = (period: string): string => {
  const now = new Date();
  switch (period) {
    case "lastYear":
      return (now.getFullYear() - 1).toString();
    default:
      return now.getFullYear().toString();
  }
};
